import { Observable } from 'rxjs/Observable';
import { AngularFirestoreCollection, AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/map';

interface Note {
  name: string;
  description?: number;
  img?: string;
}

interface Note2 {
  name: string;
  description?: number;
  img?: string;
}

interface Note3 {
  name: string;
  description?: number;
  img?: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  
  notesCollection: AngularFirestoreCollection<Note>; // collection
  notes: Observable<Note[]>; // observable
  
  notesCollection2: AngularFirestoreCollection<Note2>; // collection
  notes2: Observable<Note2[]>; // observable

  notesCollection3: AngularFirestoreCollection<Note3>; // collection
  notes3: Observable<Note3[]>; // observable

  constructor(private afs: AngularFirestore) { }

  ngOnInit() {
    
    this.notesCollection = this.afs.collection('attackingPositions') // reference
    this.notes = this.notesCollection.valueChanges() // observable data

    this.notesCollection2 = this.afs.collection('escapingPositions') // reference
    this.notes2 = this.notesCollection2.valueChanges() // observable data

    this.notesCollection3 = this.afs.collection('passingPositions') // reference
    this.notes3 = this.notesCollection3.valueChanges() // observable data

  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts